// @ts-nocheck
/* eslint-disable lines-around-comment */
// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { makeStyles } from 'tss-react/mui';
import DeviceStatus from '../../../../prejoin/components/web/preview/DeviceStatus';
// @ts-ignore
import { Toolbox } from '../../../../toolbox/components/web';
import { getConferenceName } from '../../../conference/functions';
import { PREMEETING_BUTTONS, THIRD_PARTY_PREJOIN_BUTTONS } from '../../../config/constants';
import { getToolbarButtons, isToolbarButtonEnabled } from '../../../config/functions.web';
import { connect } from '../../../redux/functions';
import { withPixelLineHeight } from '../../../styles/functions.web';
import ConnectionStatus from './ConnectionStatus';
// @ts-ignore
import Preview from './Preview';
// CUSTOM
import DeviceRoomInfo from "../../../../customise/custom/components/DeviceRoomInfo";
import { removeBoxErrorApi } from '../../../../customise/welcome-dashboard/Request.d';
import { getPublicIp } from '../../../../webjam/helper';
import { dispatch, getBaseConfig, isSocialMobileApp } from '../../../../customise/Utils';
import { FEATURE_CUSTOM_REDUX, FEATURE_CUSTOM_REDUX_V2, FEATURE_CUSTOM_REDUX_V3 } from '../../../../customise/constant';
import { ct } from '../../../../customise/constant-Utils';
import { handleToggleVideoMuted } from '../../../../toolbox/actions.any';
const useStyles = makeStyles()(theme => {
    return {
        subtitle: {
            ...withPixelLineHeight(theme.typography.heading5),
            color: theme.palette.text01,
            marginBottom: theme.spacing(4),
            overflow: 'hidden',
            textAlign: 'center',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            width: '100%'
        }
    };
});
const PreMeetingScreen = ({ _buttons, _premeetingBackground, _roomName, children, className, showDeviceStatus, skipPrejoinButton, title, videoMuted, videoTrack, 
// CUSTOM
tokenDecodedData, mediaDeviceOverlay, userLoginData, showPreJoiningConfig, conferenceJoined, childClass
// END
 }) => {
    const { classes } = useStyles();
    const containerClassName = `premeeting-screen ${className ? className : ''}`;
    const style = _premeetingBackground ? {
        background: _premeetingBackground,
        backgroundPosition: 'center',
        backgroundSize: 'cover'
    } : {};
    // CUSTOM
    const [willShow, setWillShow] = useState(false);
    useEffect(() => {
        setTimeout(function () {
            setWillShow(true);
        }, 3000);
        // delete existing device error entry which is 30 min earlier
        removeBoxErrorFn();
        setTimeout(function () {
            console.log("classNameclassName ", className);
            if (className == "lobby-screen") {
                dispatch(handleToggleVideoMuted(false, true, true));
            }
        }, 3000);
    }, []);
    // const userLoginDataUser = usePrevious(userLoginData.user);
    // useEffect(() => {
    //     if (!_.isEqual(userLoginDataUser, userLoginData.user)) {
    //         if (userLoginData.user?.is_invited == true && !userLoginData.user?.id) {
    //             dispatch(setPrejoinPageVisibility(false));
    //         }
    //     }
    // }, [userLoginData.user]);
    const removeBoxErrorFn = async () => {
        try {
            let ipAddress = await getPublicIp();
            await removeBoxErrorApi({
                device_ip: ipAddress,
                willExpire: true
            });
        }
        catch (e) {
            console.log("error unable to access user ip =>", e);
        }
    };
    // CUSTOM
    const redirectToSocialApp = () => {
        if (isSocialMobileApp()) {
            window.location.href = getBaseConfig("appReferrerUrl");
        }
        else {
            if (window.parent) {
                window.parent.location.href = getBaseConfig("socialReferrerUrl") + "/OuIVuX07";
            }
            else {
                window.location.href = getBaseConfig("socialReferrerUrl") + "/OuIVuX07";
            }
        }
    };
    // END
    // need to maintain this screen in case of duet teacher as this screen also used to show lobby knock screen
    if (tokenDecodedData) {
        if (tokenDecodedData?.teacher) {
            return null;
        }
    }
    const prejoinRedirectToSocialButton = getBaseConfig("prejoinRedirectToSocialButton");
    const showDevicePreJoining = getBaseConfig("showDevicePreJoining");
    // END
    return (React.createElement("div", { className: containerClassName },
        React.createElement("div", { className: 'position-relative ' + childClass, style: style },
            prejoinRedirectToSocialButton == true &&
                React.createElement("div", { className: 'redirect-to-social-app' },
                    React.createElement("button", { onClick: () => { redirectToSocialApp(); } },
                        React.createElement("span", { className: 'web-app-close' },
                            React.createElement("i", { className: "fa fa-angle-left fa-2x mr-2" }),
                            ct("rta-trmc.premeeting.back")),
                        React.createElement("span", { className: 'mob-app-close' },
                            React.createElement("img", { src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmCAYAAACoPemuAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAJqADAAQAAAABAAAAJgAAAACnOgJhAAABb0lEQVRYCb3YAY6CMBAFUOMJuIEewZvJjeRIewO8gdwA/+92dhOiZdrOZ5IJSKr/UaQaTifUuq539Ix+oR/ogcePKGblTGbP6HvKxc6I3hYH3dQwZqCZta2RszVvj+bXUhwyvqEYPxO2cO9LSXDIKqFIWQibuFeoUBxy9lCkTIQN6B++KlQIDp/vQdHye/NxBy3FVaPszlPimlFKXDdKgQtDReLCURE4GaoHJ0e14A5DNeC4EJfqf/G0D+/dIs2zCB+LspPqwMXPlKFs24DToxpwzaizhVVurxh/cbyHYzhWX7iUN/Te3YchfxXyl6l4ZoiqRZlOh+tA6XBOFL/o7FLFzRxSPJePoCG3HleDsi+nHNeCkuN6UDJcBCocF4kKwylQ3TglqhkHFNefvd++tE5ZSOs2Z3nWucHzUCUEZSfjxKWHKqXZCkVV4F6csSf6U0lQTtyTsPGDSopy4MY0JuM4cwt6Qh/9cJiZzKYhod4LGG8hUxJjfAAAAABJRU5ErkJggg==" })))),
            React.createElement("div", { className: 'content prejoin-content' },
                React.createElement(ConnectionStatus, null),
                React.createElement("div", { className: 'content-controls' },
                    React.createElement("h1", { className: 'title' }, title),
                    _roomName && (React.createElement("span", { className: classes.subtitle }, _roomName)),
                    children,
                    _buttons.length && React.createElement(Toolbox, { toolbarButtons: _buttons }),
                    skipPrejoinButton,
                    showDevicePreJoining == true
                        ? showPreJoiningConfig == true && !mediaDeviceOverlay && willShow == true && !conferenceJoined ? React.createElement(DeviceRoomInfo, null) : null
                        : showDeviceStatus && React.createElement(DeviceStatus, null)))),
        React.createElement(Preview, { videoMuted: videoMuted, videoTrack: videoTrack })));
};
/**
 * Maps (parts of) the redux state to the React {@code Component} props.
 *
 * @param {Object} state - The redux state.
 * @param {Object} ownProps - The props passed to the component.
 * @returns {Object}
 */
function mapStateToProps(state, ownProps) {
    const { hiddenPremeetingButtons, hideConferenceSubject } = state['features/base/config'];
    const toolbarButtons = getToolbarButtons(state);
    const premeetingButtons = (ownProps.thirdParty
        ? THIRD_PARTY_PREJOIN_BUTTONS
        : PREMEETING_BUTTONS).filter((b) => !(hiddenPremeetingButtons || []).includes(b));
    const { premeetingBackground } = state['features/dynamic-branding'];
    return {
        // For keeping backwards compat.: if we pass an empty hiddenPremeetingButtons
        // array through external api, we have all prejoin buttons present on premeeting
        // screen regardless of passed values into toolbarButtons config overwrite.
        // If hiddenPremeetingButtons is missing, we hide the buttons according to
        // toolbarButtons config overwrite.
        _buttons: hiddenPremeetingButtons
            ? premeetingButtons
            : premeetingButtons.filter(b => isToolbarButtonEnabled(b, toolbarButtons)),
        _premeetingBackground: premeetingBackground,
        _roomName: hideConferenceSubject ? undefined : getConferenceName(state),
        // CUSTOM
        tokenDecodedData: state[FEATURE_CUSTOM_REDUX].tokenDecodedData,
        mediaDeviceOverlay: state[FEATURE_CUSTOM_REDUX_V2].mediaDeviceOverlay,
        userLoginData: state[FEATURE_CUSTOM_REDUX].userLoginData,
        prejoinDeviceMessages: state[FEATURE_CUSTOM_REDUX_V3].prejoinDeviceMessages,
        conferenceJoined: state[FEATURE_CUSTOM_REDUX].conferenceJoined,
        // END
    };
}
export default connect(mapStateToProps)(PreMeetingScreen);
